import { render, staticRenderFns } from "./PrepressFavicon.vue?vue&type=template&id=be38a418&"
var script = {}
import style0 from "./PrepressFavicon.vue?vue&type=style&index=0&id=be38a418&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports